<template>
    <div id="top" v-show="isVisible" @click="scrollToTop">
		top
	</div>
</template>
<script>
import $ from 'jquery'
export default{
    name:'toTop',
    data(){
        return{
            isVisible :false,
        }
    },
    methods:{
        // 滚动事件处理
        handleScroll(){
            this.isVisible = window.scrollY  > 10;
        },
        scrollToTop(){
            $('html, body').animate({
	            scrollTop: 0
	        }, 800); // 800毫秒内滚动到顶部
        }
    },
    mounted() {
        // 在组件挂载时添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // 在组件销毁前移除事件监听
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>
<style>
</style>